"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmbedRequestInputType = void 0;
exports.EmbedRequestInputType = {
    Query: "query",
    Document: "document",
};
